// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuotedText__container-bccb52 {
  box-sizing: border-box;
  padding: 0px;
}

.QuotedText__content-efc199 {
  padding-inline-start: 8px;
}

.QuotedText__theme-1-b882a5.QuotedText__container-bccb52 {
  min-width: 200px;
}

.QuotedText__theme-1-b882a5 .QuotedText__content-efc199 {
  border-left: 2px solid var(--chat-bubble-primary);
}

.QuotedText__theme-1-b882a5 .QuotedText__title-e069f2 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--chat-bubble-primary);
}

.QuotedText__theme-2-f090de.QuotedText__container-bccb52 {
  width: auto;
  max-width: 164px;
  padding: 4px;
  border-radius: 6px;
  background: var(--average-background);
}

.QuotedText__theme-2-f090de .QuotedText__content-efc199 {
  border-left: 2px solid var(--text-on-background);
}

.QuotedText__theme-2-f090de .QuotedText__title-e069f2 {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--text-on-background);
}

.QuotedText__theme-2-f090de .QuotedText__text-f5f9f8 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--text-on-background);
  opacity: 0.7;
}

.QuotedText__theme-2-f090de .QuotedText__icon-e71f17 {
  fill: var(--text-on-background);
}

.QuotedText__theme-2-f090de a {
  color: var(--text-on-background);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/QuotedText/QuotedText.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iDAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,iCAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gCAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  padding: 0px;\n}\n\n.content {\n  padding-inline-start: 8px;\n}\n\n.theme-1.container {\n  min-width: 200px;\n}\n\n.theme-1 .content {\n  border-left: 2px solid var(--chat-bubble-primary);\n}\n\n.theme-1 .title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--chat-bubble-primary);\n}\n\n.theme-2.container {\n  width: auto;\n  max-width: 164px;\n  padding: 4px;\n  border-radius: 6px;\n  background: var(--average-background);\n}\n\n.theme-2 .content {\n  border-left: 2px solid var(--text-on-background);\n}\n\n.theme-2 .title {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--text-on-background);\n}\n\n.theme-2 .text {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--text-on-background);\n  opacity: 0.7;\n}\n\n.theme-2 .icon {\n  fill: var(--text-on-background);\n}\n\n.theme-2 a {\n  color: var(--text-on-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuotedText__container-bccb52`,
	"content": `QuotedText__content-efc199`,
	"theme-1": `QuotedText__theme-1-b882a5`,
	"theme1": `QuotedText__theme-1-b882a5`,
	"title": `QuotedText__title-e069f2`,
	"theme-2": `QuotedText__theme-2-f090de`,
	"theme2": `QuotedText__theme-2-f090de`,
	"text": `QuotedText__text-f5f9f8`,
	"icon": `QuotedText__icon-e71f17`
};
module.exports = ___CSS_LOADER_EXPORT___;
